import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { padding } from "@mui/system";
import { min } from "date-fns";
import { callback } from "chart.js/dist/helpers/helpers.core";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const BarChart = ({
  labels,
  datasets,
  colors = [],
  stacked = false,
  barThickness = 7,
  showLegend = false,
  legendPosition = "top",
  showTooltip = true,
  horizontal = false,
  onBarClick = () => {},
}) => {
  const chartData = {
  labels,
  datasets: datasets.map((ds, index) => ({
    ...ds,
    backgroundColor:
      Array.isArray(colors) && colors.length === ds.data.length
        ? colors
        : colors[index] || "#3B82F6",
    barThickness,
    borderRadius: 4,
    stack: stacked ? "default" : undefined,
  })),
};

  const handleBarClick = (event, elements) => {
    if (elements.length === 0) return;

    const element = elements[0];
    const datasetIndex = element.datasetIndex;
    const dataIndex = element.index;
    const dataset = datasets[datasetIndex];
    const label = chartData.labels[dataIndex];
    const value = dataset.data[dataIndex];
    const filterInfo = dataset.filterInfo[dataIndex];
    const clickedBarData = { label, value, filterInfo };

    onBarClick(clickedBarData);
  };

  const options = {
    indexAxis: horizontal ? "y" : "x",
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    grouped: stacked ? false : true,
    onClick: handleBarClick,
    plugins: {
      tooltip: {
        enabled: showTooltip,
        mode: "index",
        intersect: false,
        callbacks: {
          title: () => "",
          beforeBody: function (context) {
            if (stacked) {
              const total = context.reduce((sum, item) => sum + item.raw, 0);
              return `Total: ${total}`;
            }
            return "";
          },
          label: function (tooltipItem) {
            let label = tooltipItem.dataset.label || "";
            const value = tooltipItem.raw;
            if (datasets.length === 1) {
              label = tooltipItem.label || "";
            }
            return `${label}: ${value}`;
          },
        },
        displayColors: true,
        backgroundColor: "#ffffff",
        titleColor: "#1F2937",
        bodyColor: "#1F2937",
        borderColor: "#E5E7EB",
        borderWidth: 1,
        padding: 12,
        boxPadding: 6,
      },
      legend: {
        align: "end",
        display: showLegend,
        position: legendPosition,
        labels: {
          usePointStyle: true,
        },
      },
    },
    scales: {
      x: {
        stacked,
        border: {
          dash: horizontal ? [5, 5] : undefined,
        },
        ticks: {
          autoSkip: false,
        },
        grid: {
          drawOnChartArea: false,
        },
      },
      y: {
        stacked,
        beginAtZero: true,
        border: {
          dash: horizontal ? undefined : [5, 5],
        },
        ticks: {
          color: "#6B7280",
          stepSize: 1,
          precision: 0,
          callback: function (value) {
            if (Number.isInteger(value)) {
              return value;
            }
            return null;
          }
        },
        grid: {
          color: "#E5E7EB",
          drawBorder: false,
        },
      },
    },
  };

  return <Bar data={chartData} options={options} />;
};

export default BarChart;
